<template>
  <v-app>
    <!-- <Navbar/> -->
    <div>
      <v-content>    
        <v-container>
        
          <v-layout row wrap>

            <v-flex xs12 align-center justify-space-between>
              <v-card class="d-xl-flex text-xl-center" color='#26c6da'  elevation='8' outlined tile >
                
                    <h1 >Alanya Market Itäkeskus 10 v. Synttärit</h1>
               
              </v-card>            
              </v-flex>

            <v-flex lg12>
              <v-data-table
                :headers="headers"
                :items="sliders"
             :sort-by="id"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                row
                wrap
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                                   
                  <td class="text-xs-left" style="font-size: 2.5em">  {{ props.item.id }}</td> 
                  <td class="text-xs-left"><img v-bind:src="props.item.image" style="width: 450px; height: 450px"/></td> 

                  <td class="text-xs-left" style="height:150; width:400px; font-size: 2.4em">  {{ props.item.name }}</td> 
                  
                  <td >
                    
                 <v-card class="d-xs-flex-pa-2 xs-center" elevation='6'  color='green' height='100' outlined tile >
                    <v-card-text>
                  <td class="text-xs-center" align='center' v-if="props.item.show" style="height:100px; width:300px; font-size: 3.5em; color:red"> {{ props.item.winner }}</td> 
                
                  <td class="text-xs-center" v-if="!props.item.show" style="height:100px; width:300px; font-size: 3.5em; color:black "># # # # #</td> 
                    </v-card-text>
                  </v-card>
                  </td>
                  <td >
                   <v-progress-circular v-if="props.item.isrun"
      :rotate="360"
      :size="100"
      :width="15"
      :value="value"
      color="red"
    >
      {{ value }}
    </v-progress-circular>
                  </td>
                  <td class="text-xs-left">
                     <v-btn
                    @click="removeItem(props.item.id)"
                    
                    raised
                    color='red'
                    rounded
                    dark
                    large
                  >
                    Pick A Number
                  </v-btn>
                    <!-- <v-btn fab dark large color="Blue" @click="removeItem(props.item.id)">
                      <v-icon dark>add</v-icon>
                    </v-btn> -->
                  </td>
                </template>
              </v-data-table>               
            </v-flex>
          </v-layout>
        </v-container>
        <!-- Add Expense Button  -->
        <v-btn @click="CekilisYap()"
          fab
          bottom
          large
          
          right
          class="main_color"
          dark
          fixed
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-content>
    </div>
  </v-app>
</template>

<script>
  import Navbar from '@/components/admin/navbar/Navbar'
  import firebase from "firebase";
  import moment from 'moment'
   import axios from "axios";
  export default {
    name:'Slider',
    components: {
      Navbar
    },
    data(){
      return{
         interval: {},
        value: 0,
        currency:'',
        search: '',
        item:0,
        rowsPerPageItems: [10, 20, 30],
        pagination: {
        rowsPerPage: 10
        },
        headers: [
        { text: 'Order', value: 'id', sortable: !1 },
        { text: 'Prize', value: 'image', sortable: !1  },
        { text: 'Name', value: 'name', sortable: !1  },
        { text: 'Winner Number', value: 'winner', sortable: !1  },       
        { text: 'Action' , value: 'action', sortable: !1  },
        ],
        sliders:[]
      }
    },
     beforeDestroy () {
      clearInterval(this.interval)
    },
    
    methods:{
      removeItem(id){

        if(this.sliders[id-1].show)
        return;

        this.sliders[id-1].isrun=true;
        

         this.interval = setInterval(() => {
        if (this.value === 100) {
          clearInterval(this.interval)
    var db = firebase.firestore();
        var tempArray=[];
        tempArray = this.sliders;

        var itemx=  tempArray[id-1];
        itemx.show=true;
 tempArray[id-1]=itemx;

this.sliders = tempArray;

        // this.sliders.update()
         db.collection('cekilisdata').doc(id).update({show:true});
          this.sliders[id-1].isrun=false;
          return (this.value = 0)
        }
        this.value += 10
      }, 500)


 

    

        // var deleteResult = confirm("Want to delete?");
        // if (deleteResult) {
        //   db.collection('options-slider').doc(id).delete().then(() => {
        //     this.sliders = this.sliders.filter(slider => {               
        //       return slider.id != id                  
        //     })            
        //   })
        // }       
      },
    CekilisYap(){      
      let date=Date.now();
let res =  axios.get("https://europe-west1-elatukku-23ef3.cloudfunctions.net/getsampledata").
//let res =  axios.get("https://europe-west1-elatukku-23ef3.cloudfunctions.net/GetCekilisList?date=1602320400").
//let res =  axios.get("http://localhost:5001/elatukku-23ef3/europe-west1/GetCekilisList?date=1601971752").
                then(res=> {
                  console.log(res.data)

                  this.$router.go(0)
        
                })
                  .catch(error => { console.log(error); });
    }
    },
    created(){
      var db = firebase.firestore();   



      // Show All Slider
      let cref = db.collection('cekilisdata').orderBy('sira')

      cref.onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
        //  if(change.type == 'added'){
            let doc = change.doc
            this.sliders.push({
              id:doc.id,           
              image:doc.data().image,            
              name:doc.data().name,            
              winner:doc.data().winner,
              show:doc.data().show,  
              isrun:false,
            })
      //    }
        })
      })
    },  
  }
</script>

<style>
  td{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/options/Cekilis.vue